import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';

import MailSVG from '@icons/MailIcon/MailSVG';
import MessageInput from './MessageInput';
import {
    InboxContainerStyled,
    SidebarStyled,
    ContainerMainStyled,
    ContainerMainInnerStyled,
} from './MessagesInboxStyles';
import { ConversationWindowStyled, CurrentRecipientStyled } from './ConversationWindowStyled';

const MessagesInboxFake = () => (
    <div style={{ position: 'relative' }}>
        <InboxContainerStyled className="fade-in-fast">
            <SidebarStyled>
                <p className="font-size-sm" style={{ lineHeight: '1.6rem' }}>
                    After you message someone, your conversations will appear here.
                </p>
                <p className="font-size-sm" style={{ lineHeight: '1.6rem' }}>
                    Start a conversation by clicking on the{' '}
                    <span style={{ marginRight: '5px', marginLeft: '3px', display: 'inline-block' }}>
                        <MailSVG />
                    </span>
                    in a member's card.
                </p>
            </SidebarStyled>
            <ContainerMainStyled>
                <ContainerMainInnerStyled>
                    <div className="fade-in-fast" style={{ height: '507px' }}>
                        <CurrentRecipientStyled />
                        <ConversationWindowStyled>
                            <p className="font-size-sm">Your messages will appear here.</p>
                        </ConversationWindowStyled>
                        <MessageInput />
                    </div>
                </ContainerMainInnerStyled>
            </ContainerMainStyled>
        </InboxContainerStyled>
    </div>
);

export default MessagesInboxFake;
